var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10309 6.78594C3.10309 6.3303 3.47245 5.96094 3.92809 5.96094H18.0709C18.5266 5.96094 18.8959 6.3303 18.8959 6.78594C18.8959 7.24157 18.5266 7.61094 18.0709 7.61094H3.92809C3.47245 7.61094 3.10309 7.24157 3.10309 6.78594ZM3.10309 11.5002C3.10309 11.0446 3.47245 10.6752 3.92809 10.6752H18.0709C18.5266 10.6752 18.8959 11.0446 18.8959 11.5002C18.8959 11.9559 18.5266 12.3252 18.0709 12.3252H3.92809C3.47245 12.3252 3.10309 11.9559 3.10309 11.5002ZM3.10309 16.2145C3.10309 15.7589 3.47245 15.3895 3.92809 15.3895H18.0709C18.5266 15.3895 18.8959 15.7589 18.8959 16.2145C18.8959 16.6701 18.5266 17.0395 18.0709 17.0395H3.92809C3.47245 17.0395 3.10309 16.6701 3.10309 16.2145Z",
    fill: "#415066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.cc5b886c3e2c71e1ec7363252bcb7178.svg";
export { ForwardRef as ReactComponent };